export const TAB_TYPES = {
  primary: 'primary',
  secondary: 'secondary',
};
